import { React, useState } from 'react';
import '../css/PostCard.css';
import '../css/PostModal.css';

const PostCard = ({ post }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`post-card ${isOpen ? 'open' : ''}`}>
            {!isOpen ? (
                <div className="card-content" onClick={() => setIsOpen(true)}>
                    <div className="card-header">
                        <img src={post.image} alt={post.title} className="card-image" />
                        <div className="card-content">
                            <h3>{post.title}</h3>
                            <p className="card-summary">{post.summary}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="modal-content" onClick={() => setIsOpen(false)}>
                    <img src={post.image} alt={post.title} className="modal-image" />
                    <h2>{post.title}</h2>
                    <p>{post.content}</p>
                </div>
            )}
        </div>
    );
};

export default PostCard;